import * as Yup from "yup";
import {
  ClientAdvanceSourceType,
  ClientAdvanceValueType,
} from "features/ClientAdvances/constants/client-advance.constants";

const schema = Yup.object({
  sourceType: Yup.mixed<ClientAdvanceSourceType>()
    .oneOf(Object.values(ClientAdvanceSourceType))
    .required("Source type is required"),

  sourceId: Yup.number().required("The source field is required"),

  valueType: Yup.mixed<ClientAdvanceValueType>()
    .oneOf(Object.values(ClientAdvanceValueType))
    .required("Value type is required"),

  /** Rupee amount when FIXED; percentage when PERCENTAGE. */
  value: Yup.number()
    .typeError("Enter a valid number")
    .when("valueType", {
      is: ClientAdvanceValueType.FIXED,
      then: (s) =>
        s
          .positive("Amount must be greater than zero")
          .required("Amount is required"),
      otherwise: (s) =>
        s
          .positive("Percentage must be greater than zero")
          .max(100, "Percentage cannot exceed 100")
          .required("Percentage is required"),
    }),

  remarks: Yup.string().nullable(),
  purpose: Yup.string().nullable(),
  collectedByUserId: Yup.number().required("Collected by is required"),
  isEdit: Yup.boolean(),
  markAsReceived: Yup.boolean(),
  /** Required on create when markAsReceived is true (or omitted); not applicable on edit. */
  modeOfPaymentId: Yup.number()
    .nullable()
    .test(
      "required-when-marking-received",
      "Mode of payment is required",
      function (val) {
        const { isEdit, markAsReceived } = this.parent;
        if (isEdit || markAsReceived === false) return true;
        return val != null;
      },
    ),
  paymentDate: Yup.string().nullable(),
  referenceNumber: Yup.string().nullable(),
});

export default schema;
